import m from "../../geodata/es2015/belarusHigh";
window.am4geodata_belarusHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/belarusHigh.js
// module id = null
// module chunks = 